import * as angular from "angular";
import {IController} from "angular";

export class SitesTableCtrl implements IController {
  sites: any;
  onDeleteSite: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('sitesTable', {
    bindings: {
      sites: '<',
      onDeleteSite: '&'
    },
    template: require('./sites-table.html').default,
    controller: SitesTableCtrl
  });
